import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jose_",
  "use": "icon-jose_-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-jose_\">\n<polygon points=\"162.5,182.5 34.5,182.5 98.5,146.5 34.5,32.5 108.5,100 162.5,32.5 119.5,125.5 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol